export const collaborationStatus = [
  "Requested",
  "Approved",
  "Denied",
];

export default collaborationStatus;
